import '../productMenu.scss';

import { IProduct } from '@/store/ducks/products/types';

interface ProductListGridProps {
  products?: IProduct[];
  renderProduct?: (product: IProduct) => React.ReactNode;
  maxProducts?: number;
}

export function ProductListGrid({
  products = [],
  renderProduct,
  maxProducts = 20,
}: ProductListGridProps) {
  return (
    <div className="product-grid">
      {products.slice(0, maxProducts).map((product, index) => (
        <div key={index} className="product-item">
          {renderProduct ? renderProduct(product) : <div>Product {index + 1}</div>}
        </div>
      ))}
    </div>
  );
}
